module.exports = __webpack_public_path__ + "img/keys_to_put_the_foot_down.4aaa087a.jpg";